import { useQuery } from '@apollo/client'
import { type useQueryWithExtendedTimeProps } from '../utility/types'

export const useQueryWithExtendedTime = ({
  query,
  options = {}
}: useQueryWithExtendedTimeProps) => {
  const { loading, data, error, refetch } = useQuery(query, {
    ...options,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true
  })

  const QueryWithExtendedTimeComponent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center p-4">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
            <p className="text-gray-600">Loading data...</p>
            <p className="text-sm text-gray-500 mt-1">This may take a moment while the backend warms up</p>
          </div>
        </div>
      )
    }

    if (error) {
      return (
        <div className="flex items-center justify-center p-4">
          <div className="text-center text-red-600">
            <p className="font-semibold">Error loading data</p>
            <p className="text-sm mt-1">{error?.message}</p>
            <button
              onClick={async () => {
                await refetch(options?.variables)
              }}
              className="mt-2 px-4 py-2 bg-black text-white rounded hover:bg-black-600"
            >
              Try Again
            </button>
          </div>
        </div>
      )
    }

    return null
  }

  return { data, refetch, QueryWithExtendedTimeComponent, loading, error }
}
